import Resources from './map-components';

export default Resources;
